import actionTypes from '../../actions/actionTypes';

const _initState = {
  isLoading: false,
  data: null
};

const faktura = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_FAKTURA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_FAKTURA_SUCCESS:
      return { ...state, isLoading: false, data: action.res.Data };
    
    case actionTypes.GET_FAKTURA_FAILURE:
      return _initState;
  
    case actionTypes.CHANGE_FAKTURA:
      return { ...state, isLoading: false, data: action.data };

    default:
      return state
  }
};

export default faktura;